import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../constants/images";
import { SectionHead, Reveal } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const SPANS = [
  "lg:col-span-5 lg:row-span-2",
  "lg:col-span-7",
  "lg:col-span-7",
  "lg:col-span-4",
  "lg:col-span-4",
  "lg:col-span-4",
  "lg:col-span-6",
  "lg:col-span-6",
];

const TILE_IMG = [IMAGES.houses, IMAGES.pools, IMAGES.roofs, IMAGES.facades, IMAGES.masonry, IMAGES.tiling, IMAGES.concrete, IMAGES.rebar];

const ServicesBento = () => {
  const { t } = useLang();
  const items = t.services.items;

  return (
    <section id="usluge" className="relative bg-[#F4F1EA] text-[#0D0F12] py-20 sm:py-28" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <SectionHead eyebrow={t.services.eyebrow} title={t.services.title} subtitle={t.services.subtitle} />
          <Reveal delay={0.2} className="shrink-0 hidden lg:block">
            <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#0D0F12]/50 text-end leading-6">
              BOOMGRADNJA<br />EST. GRADILIŠTE<br />SARAJEVO
            </p>
          </Reveal>
        </div>

        <div className="mt-12 lg:mt-16 grid grid-cols-1 lg:grid-cols-12 lg:auto-rows-[240px] gap-4">
          {items.map((item, i) => (
            <Reveal key={i} delay={0.05 * i} className={`${SPANS[i]} h-full`}>
              <article
                data-testid={`service-tile-${i + 1}`}
                className="group relative h-full min-h-[240px] lg:min-h-0 overflow-hidden bg-[#0D0F12] clip-tg"
              >
                <img
                  src={TILE_IMG[i]}
                  alt={item.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D0F12]/95 via-[#0D0F12]/35 to-[#0D0F12]/10" />
                <div className="absolute inset-0 border border-transparent group-hover:border-[#D96B27]/60 transition-colors duration-500 pointer-events-none" />

                <span className="absolute top-4 start-5 font-mono2 text-xs tracking-[0.25em] text-[#D96B27]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="absolute top-4 end-5 w-9 h-9 flex items-center justify-center bg-[#D96B27] text-[#0D0F12] opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                  <ArrowUpRight className="w-4 h-4" />
                </span>

                <div className="absolute bottom-0 start-0 p-5 sm:p-6">
                  <h3 className="font-display font-bold text-xl sm:text-2xl text-[#F4F1EA] tracking-tight">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#F4F1EA]/75 max-w-md">{item.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesBento;
